import Layout from "../../components/mainPage/Layout";
import CronTask from "../../images/systemComponents/CronTask.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Периодические задачи
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Периодические задачи (cron tasks) в SCADA-системах — это автоматически выполняемые процессы, которые запускаются по расписанию. Они играют важную роль в автоматизации рутинных операций, повышении эффективности и обеспечении стабильной работы системы.
                    </p>
                    <p>
                        Периодические задачи позволяют SCADA NPT Expert регулярно обрабатывать информацию о состоянии оборудования, а также отправлять команды на управление устройствами.
                    </p>
                    <p>
                        Такой подход позволяет обеспечить непрерывное и точное управление технологическими процессами, а также быстро реагировать на изменения параметров, влияющих на технологические процессы (например, параметров окружающей среды). Путем периодического опроса и обработки сигналов SCADA может отслеживать изменения параметров, выявлять аварийные или потенциально аварийные ситуации, и осуществлять операции для их предотвращения или устранения.
                    </p>
                    <img
                        src={CronTask}
                        className="mb-4  w-100"
                        alt="Периодические задачи"
                    />

                    <p>
                        Ниже приведены основные варианты применения периодических задач в SCADA NPT Expert.
                    </p>

                    <ul className="mb-4 description__list">
                        <li className="mb-1 description__number-li">Генерация отчётов
                            <div>
                                <b>Формирование отчётов:</b> Автоматическое создание отчётов по заданным шаблонам (например, суточные, недельные или месячные отчёты).
                            </div>
                            <div>
                                <b>Пример:</b> Ежедневный отчёт о потреблении энергии или производственных показателях.
                            </div>
                        </li>
                        <li className="mb-1 description__number-li">Очистка данных
                            <div>
                                <b>Удаление устаревших данных:</b> Очистка архивов и баз данных от старых или ненужных данных для освобождения места.
                            </div>
                            <div>
                                <b>Пример:</b> Удаление данных, старше 6 месяцев, из архива.
                            </div>
                        </li>
                        <li className="mb-1 description__number-li">Резервное копирование
                            <div>
                                <b>Создание резервных копий:</b> Периодическое создание резервных копий конфигурации SCADA, баз данных и архивов.
                            </div>
                            <div>
                                <b>Пример:</b> Еженедельное резервное копирование базы данных SCADA.
                            </div>
                        </li>
                        <li className="mb-1 description__number-li">Мониторинг и диагностика
                            <div>
                                <b>Проверка состояния системы:</b> Периодическая проверка работоспособности SCADA-системы, сетевых устройств и подключённого оборудования.
                            </div>
                            <div>
                                <b>Отправка уведомлений:</b> Автоматическая отправка уведомлений о неполадках или сбоях.
                            </div>
                            <div>
                                <b>Пример:</b> Ежечасная проверка связи с контроллерами и отправка уведомления в случае потери связи.
                            </div>
                        </li>
                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}